var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"f-modal-alert"},[_c('div',{staticClass:"f-modal-icon f-modal-warning scaleWarning"},[_c('span',{staticClass:"f-modal-body pulseWarningIns"}),_c('span',{staticClass:"f-modal-dot pulseWarningIns"})])])
}]

export { render, staticRenderFns }